import axios from "axios";
import { getCookie } from "@util/cookie";

const apiURL = import.meta.env.VITE_TALENT_AI_BE_BASE_URL;

export const generateUserReferral = async (): Promise<any> => {
    const token = getCookie("authToken");
    return await axios({
        url: `${apiURL}/referral/generate`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        timeout: 300000, // 15 second timeout
    });
};

export const getUserReferral = async (): Promise<any> => {
    const token = getCookie("authToken");
    return await axios({
        url: `${apiURL}/referral/link`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        timeout: 300000, // 15 second timeout
    });
};

export const getUserReferralByCode = async (referralCode: string): Promise<any> => {
    return await axios({
        url: `${apiURL}/referral/${referralCode}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        timeout: 300000, // 15 second timeout
    });
};